import { Reporte } from "../../components/Reporte"

export const ClienteRepPn = () => {
    return (
        <Reporte url="ficha/reporte-buscar-clientepn" uindex="ficha/reporte-index-clientepn" nameReport="reporte-cliente-pn.xlsx" />
    )
}
